import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(5, 4),
    background: `linear-gradient(90deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main} 100%)`,
    borderRadius: 16,
    width: '100%',
    position: 'relative',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),

    '& > li': {
      position: 'relative',
      maxWidth: 'max-content',
      textAlign: 'inherit',
    },

    '&:before': {
      content: '""',
      position: 'absolute',
      top: 2,
      left: 2,
      width: 'calc(100% - 4px)',
      height: 'calc(100% - 4px)',
      borderRadius: 14,
      backgroundColor:
        theme.palette.mode === 'light'
          ? theme.palette.common.white
          : theme.palette.grey[300],
    },
  },
}));
